export interface LanguageMeta {
  cc: string;
  display: string;
  /** UI language to use for the default Bible translation when none exists for this language. */
  fallback?: string;
}

export const LANG_META: Record<string, LanguageMeta> = {
  af: { cc: "za", display: "Afrikaans", fallback: "en" },
  am: { cc: "et", display: "አማርኛ" },
  ar: { cc: "sa", display: "العربية" },
  az: { cc: "az", display: "Azərbaycan dili", fallback: "tr" },
  be: { cc: "by", display: "Беларуская", fallback: "ru" },
  bg: { cc: "bg", display: "Български", fallback: "ru" },
  bn: { cc: "bd", display: "বাংলা" },
  bs: { cc: "ba", display: "Bosanski", fallback: "ru" },
  ca: { cc: "es", display: "Català", fallback: "es" },
  cs: { cc: "cz", display: "Čeština", fallback: "en" },
  cy: { cc: "gb", display: "Cymraeg", fallback: "en" },
  da: { cc: "dk", display: "Dansk", fallback: "en" },
  de: { cc: "de", display: "Deutsch", fallback: "en" },
  el: { cc: "gr", display: "Ελληνικά", fallback: "en" },
  en: { cc: "us", display: "English" },
  es: { cc: "es", display: "Español" },
  et: { cc: "ee", display: "Eesti", fallback: "ru" },
  fa: { cc: "ir", display: "فارسی" },
  fi: { cc: "fi", display: "Suomi", fallback: "en" },
  fil: { cc: "ph", display: "Filipino", fallback: "en" },
  fr: { cc: "fr", display: "Français" },
  fy: { cc: "nl", display: "Frysk", fallback: "en" },
  gl: { cc: "es", display: "Galego", fallback: "pt" },
  gn: { cc: "py", display: "Avañe'ẽ", fallback: "es" },
  gu: { cc: "in", display: "ગુજરાતી", fallback: "hi" },
  he: { cc: "il", display: "עברית", fallback: "en" },
  hi: { cc: "in", display: "हिन्दी" },
  hr: { cc: "hr", display: "Hrvatski", fallback: "ru" },
  hu: { cc: "hu", display: "Magyar", fallback: "en" },
  ind: { cc: "id", display: "Bahasa Indonesia" },
  is: { cc: "is", display: "Íslenska", fallback: "en" },
  it: { cc: "it", display: "Italiano", fallback: "es" },
  iw: { cc: "il", display: "עברית", fallback: "he" },
  ja: { cc: "jp", display: "日本語" },
  ka: { cc: "ge", display: "ქართული", fallback: "ru" },
  km: { cc: "kh", display: "ខ្មែរ", fallback: "en" },
  kn: { cc: "in", display: "ಕನ್ನಡ", fallback: "hi" },
  ko: { cc: "kr", display: "한국어" },
  ky: { cc: "kg", display: "Кыргызча", fallback: "ru" },
  ln: { cc: "cd", display: "Lingála", fallback: "fr" },
  lo: { cc: "la", display: "ລາວ", fallback: "en" },
  lt: { cc: "lt", display: "Lietuvių", fallback: "ru" },
  lv: { cc: "lv", display: "Latviešu", fallback: "ru" },
  mk: { cc: "mk", display: "Македонски", fallback: "ru" },
  mn: { cc: "mn", display: "Монгол хэл", fallback: "ru" },
  ml: { cc: "in", display: "മലയാളം", fallback: "hi" },
  mr: { cc: "in", display: "मराठी", fallback: "hi" },
  ms: { cc: "my", display: "Bahasa Melayu", fallback: "ind" },
  my: { cc: "mm", display: "မြန်မာ", fallback: "en" },
  nb: { cc: "no", display: "Norsk bokmål", fallback: "en" },
  ne: { cc: "np", display: "नेपाली" },
  nl: { cc: "nl", display: "Nederlands", fallback: "en" },
  no: { cc: "no", display: "Norsk", fallback: "en" },
  pa: { cc: "in", display: "ਪੰਜਾਬੀ", fallback: "hi" },
  pl: { cc: "pl", display: "Polski", fallback: "en" },
  ps: { cc: "af", display: "پښتو", fallback: "fa" },
  pt: { cc: "br", display: "Português" },
  ro: { cc: "ro", display: "Română", fallback: "fr" },
  ru: { cc: "ru", display: "Русский" },
  sk: { cc: "sk", display: "Slovenčina", fallback: "en" },
  sl: { cc: "si", display: "Slovenščina", fallback: "ru" },
  sq: { cc: "al", display: "Shqip", fallback: "fr" },
  sv: { cc: "se", display: "Svenska", fallback: "en" },
  sw: { cc: "tz", display: "Kiswahili" },
  ta: { cc: "in", display: "தமிழ்", fallback: "hi" },
  te: { cc: "in", display: "తెలుగు", fallback: "hi" },
  th: { cc: "th", display: "ไทย", fallback: "en" },
  ti: { cc: "er", display: "ትግርኛ", fallback: "am" },
  tl: { cc: "ph", display: "Tagalog", fallback: "en" },
  tr: { cc: "tr", display: "Türkçe" },
  ug: { cc: "cn", display: "ئۇيغۇرچە" },
  uk: { cc: "ua", display: "Українська" },
  ur: { cc: "pk", display: "اردو" },
  uz: { cc: "uz", display: "Oʻzbekcha", fallback: "tr" },
  vi: { cc: "vn", display: "Tiếng Việt" },
  zh: { cc: "cn", display: "中文" },
  zu: { cc: "za", display: "isiZulu", fallback: "en" },
};
